import { t } from '@lingui/macro';
import { TireInQuoteItem } from 'noddi-types';
import { CarWheelPosition } from 'noddi-ui-common';
import { NoddiDropdown, TireBaseInfo } from 'noddi-ui-web';
import { TireMetaData } from './TireMetaData';

export type TirePosition = 'FRONT' | 'REAR';

interface StaggeredTirePositionSectionProps {
  tire: TireInQuoteItem;
  position: TirePosition;
  quantity: number;
  quantityOptions: { label: string; value: number }[];
  updateQuantity: (position: TirePosition, value: number) => void;
}

export const StaggeredTirePositionSection = ({
  tire,
  position,
  quantity,
  quantityOptions,
  updateQuantity
}: StaggeredTirePositionSectionProps) => {
  const isFront = position === 'FRONT';
  return (
    <div className='flex flex-col gap-1 border-b border-darkPurple pb-4'>
      <div className='flex justify-between gap-4'>
        <TireBaseInfo tire={tire.tireInventory.tire} />
        <div className='flex flex-col items-end gap-2'>
          <div className='flex items-center gap-2'>
            <CarWheelPosition rotate carSides={[`${position}_LEFT`, `${position}_RIGHT`]} />
            <span className='font-bold'>{isFront ? t`Front tires` : t`Rear tires`}</span>
          </div>

          <NoddiDropdown
            className='flex min-w-24'
            options={quantityOptions}
            onSelect={(item) => updateQuantity(position, item.value)}
            placeholder={`${quantity} ${t`pcs`}`}
            selectedOption={quantityOptions.find((option) => option.value === quantity)}
          />
        </div>
      </div>
      <TireMetaData tire={tire.tireInventory.tire} />
    </div>
  );
};
